import { Component, OnInit } from '@angular/core';
import { Ae2ActivitiesService, Ae2ActivitiesServiceGetAllQuery } from '@studios-smart/core/services/activities/activities.service';
import { Ae2GtmService } from '@studios-smart/core/services/gtm/gtm.services'
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Ga4Service } from '@studios-smart/core/services/ga4/ga4.service';
import { Ae2Ga4ModelPageView } from '@studios-smart/core/services/ga4/ga4.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [Ae2GtmService]
})
export class AppComponent implements OnInit {
  showFooter: boolean = true;
  showHeader: boolean = true;

  constructor(
    private ae2ActivitiesService: Ae2ActivitiesService,
    private ga4: Ga4Service,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this._getActiviy();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        
        const ga4Params: Ae2Ga4ModelPageView = {
          brand: 'velocity',
          page_location: window.location.href,
          page_referrer: document.referrer,
          page_title: document.title,
          page_language: 'pt-BR'
        };
        this.ga4.sendEvent('page_view', ga4Params);
      });
  }

  _getActiviy(): void {
    const query = new Ae2ActivitiesServiceGetAllQuery();
    query.active = true;
    query.show_in_activities_page = true;
    const paginator = this.ae2ActivitiesService.getAll(query);
    paginator.getAllPages$().subscribe((res) => {
      res.results.map((item) => {
        if (item.slug === 'bike') {
          localStorage.setItem('activity-kore', JSON.stringify(item));
        }
      })
    })
  }
}
